import {
  Button,
  Descriptions,
  Drawer,
  Form,
  Image,
  InputNumber,
  Modal,
  Select,
  Space,
  Table,
  Tooltip,
  Typography,
} from "antd";
import axios from "axios";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../context";
import {
  DeleteOutlined,
  EditOutlined,
  MinusCircleOutlined,
  PlusCircleOutlined,
  CheckOutlined,
  PlusOutlined,
  FileImageOutlined,
} from "@ant-design/icons";

const MerchantOrdersDetails = ({
  open,
  close,
  setLoading,
  getMerchantOrderSaveList,
  selectedData,
  productList,
}) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  const scroll = {};
  const [orderDetailsList, setOrderDetailsList] = useState({
    data: [],
    ready: false,
  });
  const [specProductInfo, setSpecProductInfo] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const [openConfirmDiag, setOpenConfirmDiag] = useState(false);
  const [totalCost, setTotalCost] = useState(0);
  const [inputtedPayment, setInputtedPayment] = useState(null);
  const [dialogData, setDialogData] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [ePaymentDialog, setEPaymentDialog] = useState(false);
  const [editDialog, setEditDialog] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [addProductToOrder, setAddProductToOrder] = useState(false);
  const [count, setCount] = useState(1);
  const [visible, setVisible] = useState(false);
  const scaleStep = 0.5;

  const tableProps = {
    bordered: false,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Product",
      dataIndex: "product",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Description",
      dataIndex: "description",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Price x Quantity",
      align: "right",
      render: (text, record) => (
        <p>
          &#8369;{text.price} x {text.quantity}
        </p>
      ),
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      render: (text) => (
        <p
          style={{
            width: window.innerWidth > 575 ? "auto" : 90,
            display: text.payment_method === "ecash" ? "none" : "block",
          }}
        >
          <Tooltip title="Edit">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setDialogData(text);
                setCount(parseInt(text.quantity));
                setEditDialog(true);
              }}
              icon={<EditOutlined />}
              style={{ marginRight: 10 }}
            />
          </Tooltip>
          <Tooltip title="Delete">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setDialogData(text);
                setDeleteDialog(true);
              }}
              icon={<DeleteOutlined />}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getMerchantInvoiceDetails = useCallback(() => {
    var params = {
      user_id: userData.data.id,
      transaction_id: selectedData !== null ? selectedData.transaction_id : "",
    };
    axios
      .get("user/merchant/spec-transaction-info", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setOrderDetailsList({ data, ready: true });
        setTotalCost(calculateTotal(data));
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id, selectedData]);

  const calculateTotal = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total += parseFloat(data[i].quantity) * parseFloat(data[i].price);
    }
    return total;
  };

  const handleFetchProduct = (prodID) => {
    var params = {
      id: prodID,
      user_id: userData.data.id,
    };
    setSpecProductInfo({ data: [], ready: false });
    axios
      .get("user/merchant/spec-product-info", {
        params,
      })
      .then((response) => {
        const data = response.data;
        console.log("DATA", data);
        setSpecProductInfo({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  const handleClearTransaction = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append(
      "transaction_id",
      selectedData !== null ? selectedData.transaction_id : ""
    );
    for (const name in values) {
      formdata.append(name, values[name]);
    }
    var error = [];
    if (parseFloat(inputtedPayment) < parseFloat(totalCost)) {
      error = "error";
    }
    if (error.length > 0) {
      rerunNotif("error", "Payment input invalid.");
    } else {
      setLoadings(true);
      setLoading(true);
      axios
        .post("user/merchant/confirm-payment", formdata)
        .then((response) => {
          const data = response.data;
          if (data === "success") {
            rerunNotif("success", "Confirm payment successfully.");
            setTimeout(() => {
              close();
              setLoadings(false);
              setLoading(false);
              getMerchantOrderSaveList();
            }, 1000);
          }
        })
        .catch((error) => {
          setLoadings(false);
        });
    }
  };

  useEffect(() => {
    getMerchantInvoiceDetails();
  }, [getMerchantInvoiceDetails]);

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setDeleteDialog(false);
      setConfirmLoading(false);
      handleDeleteProductInOrder();
    }, 2000);
  };

  const handleEPaymentOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setEPaymentDialog(false);
      setConfirmLoading(false);
      handleConfirmEPaymentAsPaid();
    }, 2000);
  };

  const handleDeleteProductInOrder = () => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("id", dialogData !== null ? dialogData.id : "");
    formdata.append(
      "transaction_id",
      selectedData !== null ? selectedData.transaction_id : ""
    );
    setLoadings(true);
    axios
      .post("user/merchant/delete-product-in-order", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Delete product successfully.");
          setTimeout(() => {
            if (orderDetailsList.data.length === 1) {
              close();
              setLoadings(false);
              setLoading(false);
              getMerchantOrderSaveList();
            } else {
              setLoadings(false);
              getMerchantInvoiceDetails();
            }
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  const handleConfirmEPaymentAsPaid = () => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("payment", totalCost);
    formdata.append(
      "transaction_id",
      selectedData !== null ? selectedData.transaction_id : ""
    );
    setLoadings(true);
    axios
      .post("user/merchant/confirm-epayment", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Confirm payment as paid successfully.");
          setTimeout(() => {
            close();
            setLoadings(false);
            setLoading(false);
            getMerchantOrderSaveList();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  const handleEditQtyProduct = () => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("id", dialogData !== null ? dialogData.id : "");
    formdata.append(
      "transaction_id",
      selectedData !== null ? selectedData.transaction_id : ""
    );
    formdata.append("quantity", count);

    setLoadings(true);
    axios
      .post("user/merchant/edit-product-in-order", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Updated product successfully.");
          setTimeout(() => {
            setLoadings(false);
            getMerchantInvoiceDetails();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("ERROR: ", error);
        setLoadings(false);
      });
  };

  // console.log("selectedData", selectedData);

  const handleAddProductToOrder = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append(
      "transaction_id",
      selectedData !== null ? selectedData.transaction_id : ""
    );
    formdata.append(
      "merchant_id",
      orderDetailsList.ready && orderDetailsList.data[0].merchant_id
    );
    formdata.append(
      "commissary_id",
      orderDetailsList.ready && orderDetailsList.data[0].commissary_id
    );
    formdata.append(
      "customer_name",
      orderDetailsList.ready && orderDetailsList.data[0].customer_name
    );
    formdata.append(
      "table_no",
      orderDetailsList.ready && orderDetailsList.data[0].table_no
    );
    formdata.append(
      "product",
      specProductInfo.ready && specProductInfo.data.product
    );
    formdata.append(
      "description",
      specProductInfo.ready && specProductInfo.data.description
    );
    formdata.append(
      "price",
      specProductInfo.ready && specProductInfo.data.price
    );
    formdata.append(
      "service_category",
      orderDetailsList.ready && orderDetailsList.data[0].service_category
    );
    formdata.append(
      "status",
      orderDetailsList.ready && orderDetailsList.data[0].status
    );

    for (const name in values) {
      formdata.append(name, values[name]);
    }

    setLoadings(true);
    axios
      .post("user/merchant/new-product-in-order", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "New product added successfully.");
          setTimeout(() => {
            setAddProductToOrder(false);
            setLoadings(false);
            getMerchantInvoiceDetails();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  return (
    <Drawer
      title="Payment"
      width={window.innerWidth > 500 ? 600 : "100vw"}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      {selectedData !== null && (
        <>
          {orderDetailsList.ready &&
            orderDetailsList.data[0].payment_method === "ecash" && (
              <div>
                <Image
                  width={200}
                  style={{
                    display: "none",
                  }}
                  src=""
                  preview={{
                    visible,
                    scaleStep,
                    src: `${process.env.REACT_APP_API_IMAGE}payment/${orderDetailsList.data[0].payment_attachment}`,
                    onVisibleChange: (value) => {
                      setVisible(value);
                    },
                  }}
                />
              </div>
            )}

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: 5,
            }}
          >
            <div style={{ flexGrow: 1 }} />
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => setAddProductToOrder(true)}
              style={{
                display:
                  orderDetailsList.ready &&
                  orderDetailsList.data[0].payment_method === "ecash"
                    ? "none"
                    : "block",
              }}
            >
              Product
            </Button>

            <Button
              type="primary"
              icon={<FileImageOutlined />}
              onClick={() => setVisible(true)}
              style={{
                display:
                  orderDetailsList.ready &&
                  orderDetailsList.data[0].payment_method === "ecash"
                    ? "block"
                    : "none",
              }}
            >
              View Attachment
            </Button>
          </div>
          <div style={{ overflowX: "auto" }}>
            <Table
              {...tableProps}
              pagination={false}
              columns={tableColumns}
              dataSource={
                orderDetailsList.data.length > 0 ? orderDetailsList.data : []
              }
              scroll={scroll}
              rowKey={(record) => record.product}
            />
            <div style={{ display: "flex", padding: 15 }}>
              <div style={{ flexGrow: 1 }} />
              <Typography style={{ fontWeight: "bold", fontSize: 18 }}>
                Total: &#8369;
                {totalCost.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
            </div>
          </div>
        </>
      )}

      <Button
        type="primary"
        loading={loadings}
        style={{ width: "100%", borderRadius: "20px" }}
        onClick={() => {
          if (
            orderDetailsList.ready &&
            orderDetailsList.data[0].payment_method === "ecash"
          ) {
            setEPaymentDialog(true);
          } else {
            setOpenConfirmDiag(true);
          }
        }}
      >
        {!loadings
          ? orderDetailsList.ready &&
            orderDetailsList.data[0].payment_method === "ecash"
            ? "Confirm Payment"
            : "Pay"
          : "Loading"}
      </Button>

      <Modal
        title=""
        open={openConfirmDiag}
        onCancel={() => setOpenConfirmDiag(false)}
        footer={null}
      >
        <Form
          layout="vertical"
          name="basic"
          initialValues={{ total_cost: totalCost }}
          onFinish={handleClearTransaction}
          autoComplete="off"
        >
          <Space
            direction="vertical"
            style={{ width: "100%", margin: 0, marginTop: 20 }}
          >
            <Form.Item name="total_cost" label="Total Cost">
              <InputNumber
                min={1}
                max={999999999999}
                initialvalues={0}
                // value={totalCost}
                size="large"
                style={{ width: "100%" }}
                step="0.01"
                disabled
                // onChange={(value) => setInputtedPayment(value)}
              />
            </Form.Item>

            <Form.Item
              name="customer_payment"
              label="Customer Payment"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <InputNumber
                min={1}
                max={999999999999}
                initialvalues={0}
                size="large"
                style={{ width: "100%" }}
                step="0.01"
                onChange={(value) => setInputtedPayment(value)}
              />
            </Form.Item>

            {console.log("inputtedPayment", inputtedPayment)}
            {parseFloat(inputtedPayment) !== 0 && inputtedPayment !== null && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  border: "1px solid green",
                }}
              >
                <Typography style={{ fontSize: 22, fontWeight: "bold" }}>
                  &#8369;
                  {parseFloat(
                    parseFloat(inputtedPayment) - parseFloat(totalCost)
                  ).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </Typography>
                <Typography style={{ color: "green", fontWeight: "bold" }}>
                  Change
                </Typography>
              </div>
            )}
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              loading={loadings}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
            >
              {loadings ? "Loading" : "Pay"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="Are you sure to delete this product?"
        open={deleteDialog}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setDeleteDialog(false)}
      />

      <Modal
        title=""
        open={editDialog}
        onCancel={() => setEditDialog(false)}
        footer={null}
        // width={350}
      >
        {dialogData !== null && (
          <>
            <Descriptions title="Product Info" column={1}>
              <Descriptions.Item
                label="Product"
                contentStyle={{
                  fontWeight: "bold",
                }}
              >
                {dialogData.product}
              </Descriptions.Item>
              <Descriptions.Item
                label="Description"
                contentStyle={{
                  fontWeight: "bold",
                }}
              >
                {dialogData.description}
              </Descriptions.Item>
              <Descriptions.Item
                label="Price"
                contentStyle={{
                  fontWeight: "bold",
                }}
              >
                &#8369;{dialogData.price}
              </Descriptions.Item>
            </Descriptions>
            <div
              style={{
                border: "1px solid #e5e5e5",
                marginTop: 10,
                marginBottom: 10,
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  type="dashed"
                  shape="circle"
                  onClick={() => {
                    setCount(count - 1);
                  }}
                  icon={<MinusCircleOutlined />}
                  disabled={count === 1 ? true : false}
                />
                <Typography.Title
                  level={4}
                  style={{ marginLeft: 10, marginRight: 10, marginTop: 10 }}
                >
                  {/* {console.log("count", count)} */}
                  {count}
                </Typography.Title>
                <Button
                  type="dashed"
                  shape="circle"
                  onClick={() => {
                    setCount(count + 1);
                  }}
                  icon={<PlusCircleOutlined />}
                  // disabled={count === 1 ? true : false}
                />
              </div>
            </div>

            <div>
              <Button
                type="primary"
                //   shape="circle"
                onClick={handleEditQtyProduct}
                icon={<CheckOutlined />}
                // disabled={count === 1 ? true : false}
                style={{ width: "100%" }}
              >
                Update
              </Button>
            </div>
          </>
        )}
      </Modal>

      <Modal
        title=""
        open={addProductToOrder}
        onCancel={() => setAddProductToOrder(false)}
        footer={null}
        // width={350}
      >
        <Form
          layout="vertical"
          name="basic"
          initialValues={{ remember: false }}
          onFinish={handleAddProductToOrder}
          autoComplete="off"
        >
          <Space
            direction="vertical"
            style={{ width: "100%", margin: 0, marginTop: 20 }}
          >
            <Form.Item
              name="product_id"
              label="Product"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select
                placeholder="Select product"
                onChange={(e) => {
                  handleFetchProduct(e);
                }}
                size="large"
                showSearch
              >
                {productList.data.length > 0 ? (
                  productList.data.map((data, index) => (
                    <Select.Option value={data.id} key={index}>
                      {data.product}
                    </Select.Option>
                  ))
                ) : (
                  <Select.Option value="">No product found!</Select.Option>
                )}
              </Select>
            </Form.Item>

            <Form.Item
              name="quantity"
              label="Quantity"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <InputNumber
                min={1}
                max={999999999999}
                initialvalues={0}
                size="large"
                style={{ width: "100%" }}
                step="1"
                // onChange={(value) => setInputtedPayment(value)}
              />
            </Form.Item>
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              loading={loadings}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
            >
              {loadings ? "Loading" : "Add"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="Are you sure to confirm this transaction as paid?"
        open={ePaymentDialog}
        onOk={handleEPaymentOk}
        confirmLoading={confirmLoading}
        onCancel={() => setEPaymentDialog(false)}
      />
    </Drawer>
  );
};

export default MerchantOrdersDetails;
